import React, { useState, useRef, useEffect } from 'react';
import CKEditor, { IEditEvent, IEdit } from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'custom-ckedit';
import './CkEdit.less';

type IEditPlugin =
  | '|'
  | 'heading'
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strikethrough'
  | 'bulletedList'
  | 'numberedList'
  | 'link'
  | 'blockQuote'
  | 'insertTable'
  | 'codeBlock'
  | 'MathType'
  | 'horizontalLine'
  | 'imageUpload';

export type IListeners = {
  listener: () => void;
  useCapture?: boolean;
}[];

export interface ICkEditProps {
  /** 仅查看 */
  justView?: boolean;
  /** 编辑器change */
  onChange?: (eve: IEditEvent, edit: IEdit) => void;
  /** 编辑器内容 */
  data?: string;
  /** 是否仅读 */
  disabled?: boolean;
  /** 图片上传地址 */
  uploadUrl?: string;
  /** 图片上传后的回调函数 */
  uploadCallback?: (res: any) => string;
  /** 启用的功能，最上方demo展现了全部功能 */
  toolbar?: IEditPlugin[];
  /** className */
  className?: string;
  /** placeholder */
  placeholder?: string;
}
type Props = ICkEditProps;

const xss = require('xss');

export function CkEdit(props: Readonly<Props>) {
  const {
    uploadUrl = `${process.env.REACT_APP_PUBLIC_URL}/api/file`,
    toolbar = [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      '|',
      'bulletedList',
      'numberedList',
      'link',
      'blockQuote',
      'insertTable',
      'codeBlock',
      'MathType',
      'horizontalLine',
      'imageUpload'
    ],
    uploadCallback = (res: any) => {
      return res.previewUrl;
    },
    data = '',
    className = '',
    onChange,
    placeholder = '',
    justView,
    disabled
  } = props;
  const [fnList, setFnList] = useState<IListeners>([]);

  const blur = () => {
    fnList.forEach(item => {
      document.addEventListener('input', item.listener, item.useCapture);
    });
  };

  const focus = () => {
    // @ts-ignore
    const inputEventData: IListeners = document.inputEventData || [];

    setFnList(inputEventData);

    inputEventData.forEach(item => {
      document.removeEventListener('input', item.listener, item.useCapture);
    });
  };

  return (
    <div className={`common-presenter k-common-ck-edit ${className}`}>
      {justView ? (
        <div
          className="ck ck-content ck-rounded-corners"
          dangerouslySetInnerHTML={{ __html: xss(data) }}
        />
      ) : (
        <CKEditor
          editor={ClassicEditor}
          data={data}
          onChange={onChange}
          onBlur={blur}
          onFocus={focus}
          config={{
            language: 'zh-cn',
            simpleUpload: {
              uploadUrl,
              uploadCallback
            },
            image: {
              resizeUnit: 'px',
              toolbar: ['imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight'],
              styles: ['full', 'alignLeft', 'alignRight']
            },
            toolbar,
            heading: {
              options: [
                { model: 'paragraph', title: '段落', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: '一级标题', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: '二级标题', class: 'ck-heading_heading2' },
                { model: 'heading3', view: 'h3', title: '三级标题', class: 'ck-heading_heading3' }
              ]
            },
            placeholder,
            table: {
              contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
            }
          }}
          disabled={disabled}
        />
      )}
    </div>
  );
}

export default CkEdit;
